<h2 mat-dialog-title>{{ data.item ? 'Editar Serviço de Logística Reversa' : 'Novo Serviço de Logística Reversa' }}</h2>

<mat-dialog-content>
  <form [formGroup]="form">
    <div class="row">
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Descrição</mat-label>
          <input matInput formControlName="descricao" placeholder="Ex: SEDEX Reverso" required>
          @if (form.get('descricao')?.hasError('required')) {
          <mat-error>A descrição é <strong>obrigatória</strong></mat-error>
          }
        </mat-form-field>
      </div>
      <div class="col-12">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Código do serviço</mat-label>
          <input matInput formControlName="codigoServico" placeholder="Ex: 03310">
          <mat-hint>Opcional</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" (click)="confirmar()" [disabled]="form.invalid">Salvar</button>
</mat-dialog-actions>